import { submitForm } from './submit';

export interface UploadedFile {
  id: number;
  url: string;
  /** Smaller rendition for previews, when the API provides one. */
  thumbUrl?: string;
}

/** Legacy limit of every admin upload form. */
export const MAX_UPLOAD_KB = 3000;

/** File payload shapes of the admin API (`id` | `file_id`, `file_url` | `thumb_140_140`). */
export interface RawFile {
  id?: number;
  file_id?: number;
  file_url?: string;
  thumb_140_140?: string;
}

/** Normalises a raw API file, or null when it is empty (the API returns `[]` for "no file"). */
export const toUploadedFile = (raw: RawFile | RawFile[] | null | undefined): UploadedFile | null => {
  if (!raw || Array.isArray(raw)) return null;
  const id = raw.id ?? raw.file_id;
  if (!id) return null;
  return { id, url: raw.file_url ?? raw.thumb_140_140 ?? '', thumbUrl: raw.thumb_140_140 ?? raw.file_url };
};

/** Upload that must yield a usable file. */
export async function uploadImage(
  url: string,
  file: File,
  extra: Record<string, string | number> = {},
): Promise<UploadedFile> {
  const uploaded = toUploadedFile(await uploadFile<RawFile>(url, file, extra));
  if (!uploaded) throw new Error('Не удалось загрузить файл');
  return uploaded;
}

interface UploadEnvelope<T> {
  success?: number;
  data?: T;
}

/** Multipart upload of a single `file`; resolves with the envelope `data` payload. */
export async function uploadFile<T>(
  url: string,
  file: File,
  extra: Record<string, string | number> = {},
): Promise<T> {
  const res = await submitForm<UploadEnvelope<T>>(url, { ...extra, file });
  return res.data as T;
}

export const deleteFile = (url: string, id: number) => submitForm(url, { id });
